






import Vue from "vue";
import UsageHistoryOfAmount from "@/components/templates/UsageHistoryOfAmount/index.vue";
import testData from "@/shared/testData.js";

export default Vue.extend({
  components: { UsageHistoryOfAmount },
  data() {
    return {
      usageHistoryList: testData.usageHistoryOfAmount,
    };
  },
  methods: {
    handleOnSearch(val: any) {
      this.$emit("getUsageHistory", val);
    },
  },
});
